import { render, staticRenderFns } from "./RhUsers.vue?vue&type=template&id=96b8df4e&scoped=true"
import script from "./RhUsers.vue?vue&type=script&lang=js"
export * from "./RhUsers.vue?vue&type=script&lang=js"
import style0 from "./RhUsers.vue?vue&type=style&index=0&id=96b8df4e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96b8df4e",
  null
  
)

export default component.exports